import { render, staticRenderFns } from "./AddSomething.vue?vue&type=template&id=576a905c"
import script from "./AddSomething.vue?vue&type=script&lang=js"
export * from "./AddSomething.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports